export enum CreativeTypes {
    VIDEO = 'VIDEO',
    IMAGE = 'IMAGE',
}
